import { render, staticRenderFns } from "./oldStat.vue?vue&type=template&id=54257043"
import script from "./oldStat.vue?vue&type=script&lang=js"
export * from "./oldStat.vue?vue&type=script&lang=js"
import style0 from "./oldStat.vue?vue&type=style&index=0&id=54257043&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports